// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2w32o","question":"Question_question__3FLnX","description":"Question_description__2scte"};